





























































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import YcColorPicker from "@/components/color-picker/index.js";
import compontentForm from '../../../components/form.vue'
import {
  typesettingOptions,
  fontFaceList,
  predefineColors,
  formAddList,
  borderRadiusOptions,
  borderStyleOptions,
  fontSizeOptions,
  backgroundOptions
} from '../../../constant/options';
import {PopSettingsVO, TFormSaveDetailRequest} from "@/model/FormWheel";
import discountDialog from '../../../components/discountDialog.vue';
import { getCompanyInfo } from "@/model/CompanyInfo";

@Component({
  components: {
    "yc-color-picker": YcColorPicker,
    'compontent-form': compontentForm,
    discountDialog: discountDialog,
  },
})
export default class wheelOfFortuneTextEnd extends Vue {

  @Prop(String)
  activePageSetting!:string;

  @Prop(Object)
  formData!:TFormSaveDetailRequest<PopSettingsVO>;
  formDataStart: TFormSaveDetailRequest<PopSettingsVO> = this.formData;

  @Prop(Number)
  triggerEventType!:any

  @Prop(Array)
  countryList!:any

  // 选择框选项
  get formAddList() {
    if(this.formData.settings.combinationType == 2){
      return formAddList.filter((item) => {
        if(item.label != 'Email'){
          return item
        }
      })
    }else{
      return formAddList;
    }
  }
  predefineColors = predefineColors;
  fontFaceList = fontFaceList;
  borderRadiusOptions = borderRadiusOptions;
  borderStyleOptions = borderStyleOptions;
  fontSizeOptions = fontSizeOptions;
  backgroundOptions = backgroundOptions;
  typesettingOptions = typesettingOptions;

  emailOpen:boolean = this.formData.settings.rules.emailOpen === true && this.formData.settings.rules.emailPosition === 'end';
  couponCodeShow:boolean = this.formData.settings.rules.couponCodeShow === true && this.formData.settings.rules.couponCodePosition === 'end';
  collapseArr =  ['1','2']
  formList = this.formData.settings.end
  compontentFormIsShow = false
  formType = {}

  uploadUrl = process.env.VUE_APP_UPLOAD_API + "/upload/formImage";
  uploadDialogVisible = false;
  uploadDialogUrl = '';

  bgUploadFileList: {name: string, url: string}[] = [];
  bgUploadShow = false;

  showDiscountDialog = false;

  get enableFormOptimize() {
    return true;
  }

  get company33aPopDisable() {
    const disablePop = (JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id == 33 && this.formData?.id == '55abadf02473424aa42004745e4b74f6'
    || JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id == 30 && this.formData?.id == '8eaf5e5c7d244b65bc9843e98f33d08d')
    return disablePop;
  }

  get formStyle() {
    const rules = this.formDataStart.settings.rules;
    return `
      .cartx-option-columns{
        min-width: ${Math.floor(100 /(rules.optionColumns||1)) -3}%!important;
        color: ${rules.optionColor}!important;
      }
      .cartx-option-columns .el-checkbox__input.is-checked .el-checkbox__inner,
      .cartx-option-columns .el-radio__input.is-checked .el-radio__inner {
        border-color: ${rules.optionBackground}!important;
        background: ${rules.optionBackground}!important;
      }
      .cartx-question {
        color: ${rules.optionColor}!important;
      }
      .cartx-form .el-input__inner {
        border-width: ${rules.inputType === 'bottom'? '0 0 1px 0':'1px'}!important;
        border-style: ${rules.inputBorderStyle}!important;
        border-color: ${rules.inputBorderColor}!important;
        border-radius: ${rules.inputBorderRadius}!important;
        background: ${rules.inputBackgroundShow !== 'none'? rules.inputBackground: 'none'}!important;
        color: ${rules.inputColor}!important;
      }
      .cartx-form input::-webkit-input-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
      .cartx-form input:-moz-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
      .cartx-form input::-moz-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
      .cartx-form input:-ms-input-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
    `
  }

  get token() {
    return localStorage.getItem("token") || "default";
  }

  get isPopZhuanpan() {
    const tid = `${Number(this.$route.query.templateid) || this.formData.templateId}`;
    return this.formData.popWindowWheel === 1 || tid === '36' || tid === '37' || tid === '38' || tid === '39' || tid === '40' || tid === '42' || tid === '43' || `${this.formData.id}` === '1e1609bc024d4517989039886ac7ed34' || `${this.formData.id}` === 'abdac5d809824d8280ffff395a854a15';
  }

  get showDiscountSetting() {
    return sessionStorage.getItem('isShopify') === '1';
    // const company = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    // const companyId = company?.id;
    // return ((companyId === 30 || companyId === 563 || companyId === 565 || companyId === 577 || companyId === 578 || companyId === 579 || companyId === 580 || companyId === 581 || companyId === 582 || companyId === 680 || companyId === 681)) && this.triggerEventType !== 3;
  }

  discountType = 'guding';

  // TODO: discountType联动
  changeDiscountType() {
    if (this.discountType === 'guding') {
      this.formDataStart.settings.discount = null;
      this.showDiscountDialog = false;
    } else {
      this.showDiscountDialog = true;
    }
    this.discountType = 'guding';
    // this.formDataStart.settings.discountType = 'guding';
    this.changeStart();
  }
  showDiscountDialogHandle() {
    this.showDiscountDialog = true;
  }
  saveDiscount(discount:any) {
    this.formDataStart.settings.rules.couponCode = '';
    this.formDataStart.settings.discount = discount;
    // this.formDataStart.settings.discountType = 'dongtai';
    this.discountType = 'dongtai';
    this.showDiscountDialog = false;
    this.changeStart();
  }
  closeDiscount() {
    if (this.discountType === 'guding') {
      // this.formDataStart.settings.discountType = 'guding';
      this.discountType = 'guding';
      // this.changeStart();
    }
    this.showDiscountDialog = false;
  }


  changeFormList(e:any){
    this.formDataStart.settings.end = e
    this.changeStart()
  }
  changcompontentFormIsShow(e:boolean){
    this.compontentFormIsShow= e
  }

  changeImgPosition() {
    if (this.formDataStart?.settings?.typesetting?.imgPosition != 'background') {
      this.formDataStart.settings.typesetting.bgbox = false;
    }
    this.changeStart();
  }

  changeStart(){
    this.$emit('change',this.formDataStart)
  }

  changeCouponCodePosition(){
    if (this.couponCodeShow) {
      if(this.formData.settings.rules.couponCodePosition === 'start'){
        this.$message.warning('开始页面已经展示coupon')
        this.couponCodeShow = false
      }else{
        this.formDataStart.settings.rules.couponCodePosition = 'end'
        this.formDataStart.settings.rules.couponCodeShow = this.couponCodeShow
      }
    }else{
      if(this.formData.settings.rules.couponCodePosition === 'start'){
        this.formData.settings.rules.couponCodePosition = 'start'
      }else{
        this.formData.settings.rules.couponCodePosition = ''
      }
      // 浮条的开启，前置条件coupon展示必须也要开启；浮条可以单独开启关闭；coupon展示关闭，浮条则关闭
      this.formData.settings.banner.floatBannerShow = false;
    }
        this.changeStart()
  }
  changeCouponCodeType() {
    this.changeStart()
  }
  addFormAddList(item:any,index:number){
    if (this.collapseArr.indexOf("1") < 0) {
      this.collapseArr.push('1')
    }
    if(item.type !== '自定义'){
      let a = this.formList.filter((i:any)=>{
        return i.type === item.type
      })

      if(a.length > 0){
        this.formType = a[0]
        this.compontentFormIsShow = true
        return
      }
      let b = this.formDataStart.settings.start.filter((i:any)=>{
        return i.type === item.type
      })
      if(b.length > 0){
        this.$message.error("您添加了多个"+ item.label +"表单，请检查设置是否有误")
        return
      }
    }
    if(this.formList.length < 8){
      this.formType = item
      this.compontentFormIsShow = true
    }else{
      this.$message.error("最多只能添加8个表单")
    }

  }

  @Watch('formData.settings.typesetting.imgUrl', {immediate: true})
  typesettingImgUrlChange(val:string){
    if (val) {
      this.bgUploadShow = true;
      this.bgUploadFileList  = [
        {
          name:'',
          url: val,
        }
      ]
    }
  }
  @Watch('formData.settings.rules.emailOpen')
  emailOpenChange(val:boolean){
    if (val === true && this.formData.settings.rules.emailPosition === 'end') {
      this.emailOpen = true
    }
  }

  @Watch('formData.settings.rules.emailPosition')
  emailPositionChange(val:string){
    if (this.formData.settings.rules.emailOpen === true && this.formData.settings.rules.emailPosition === 'end') {
      this.emailOpen = true
    }
  }

  @Watch('formData.settings.rules.couponCodeShow')
  couponCodeShowChange(val:boolean){
    if (val === true && this.formData.settings.rules.couponCodePosition === 'end') {
      this.couponCodeShow = true
    }
  }

  @Watch('formData.settings.rules.couponCodePosition')
  couponCodePositionChange(val:string){
    if (this.formData.settings.rules.couponCodeShow === true && this.formData.settings.rules.couponCodePosition === 'end') {
      this.couponCodeShow = true
    }
  }

  mounted() {
    if (!!this.formDataStart.settings.rules.couponCode || !this.formDataStart.settings.discount) {
        this.discountType = 'guding';
      } else {
        this.discountType = 'dongtai';
      }
  }

  @Watch('formData')
  changeFormData(){
    this.formDataStart =this.formData;
    // if (!this.formDataStart.settings.discountType) {
      if (!!this.formDataStart.settings.rules.couponCode || !this.formDataStart.settings.discount) {
        this.discountType = 'guding';
      } else {
        this.discountType = 'dongtai';
      }
    // }
  }

  @Watch("formData.settings.end")
  changeEndFormList(val:any){
    this.formList = val
  }

  /**
   * 图片上传失败钩子函数
   */
  bgHandleError(e: any): void {
    this.bgUploadShow = false;
    this.$message.warning("图片上传失败！");
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert("登录失效，请重新登录");
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect='+ encodeURIComponent(this.$router.currentRoute.fullPath)
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  bgHandleSuccess(
    res: { data: { url: string, message:string }[] },
    file: any,
    fileList: any
  ): void {
    this.bgUploadShow = true;
    if(res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.imgUrl = res.data[0].url);
      this.bgUploadFileList = res.data[0].url ? [{name: '', url: res.data[0].url}]: [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.bgUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  bgBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE =
      file.type === "image/jpeg" ||
      file.type === "image/gif" ||
      file.type === "image/png";
    if (!isIMAGE) {
      this.$message.error("上传文件只能是图片格式!");
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error("上传的图片大小不超过500kb");
      return false;
    }
    this.bgUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  bgUploadUrlDelete() {
    this.bgUploadShow = false;
    this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.imgUrl = '');
  }

  uploadUrlPreview(file: any) {
    this.uploadDialogUrl = file.url;
    this.uploadDialogVisible = true;
  }

}
